<template>
  <v-layout row>
    <v-flex xs12 class="mx-5 my-3">
      <!-- <v-flex xs12 sm6 offset-sm3> -->
      <v-card>
        <v-img
          ssrc="https://cdn.vuetifyjs.com/images/lists/ali.png"
          src="https://cdn.pixabay.com/photo/2016/02/08/23/36/isolated-1188036_1280.png"
          :sssrc="contact.picture"
          height="300px"
        >
          <v-layout column fill-height>
            <v-card-title>
              <v-btn dark icon>
                <v-icon>chevron_left</v-icon>
              </v-btn>

              <v-spacer />

              <v-btn dark icon>
                <v-icon>more_vert</v-icon>
              </v-btn>
            </v-card-title>

            <v-spacer />

            <v-card-title class="white--text pl-5 pt-5">
              <div class="display-1 pl-5 pt-5 text--primary">
                Dr {{ contact.username }}
              </div>
            </v-card-title>
          </v-layout>
        </v-img>

        <v-list two-line>
          <v-list-tile>
            <v-list-tile-action>
              <v-icon color="indigo">timeline</v-icon>
            </v-list-tile-action>

            <v-list-tile-content>
              <v-list-tile-title>{{ residencyYear }}</v-list-tile-title>
              <v-list-tile-sub-title>{{ $t('profile.ResidencyYear') }}</v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>

          <v-list-tile>
            <v-list-tile-action>
              <v-icon color="indigo">calendar_today</v-icon>
            </v-list-tile-action>

            <v-list-tile-content>
              <v-list-tile-title>{{ residencyStart }}</v-list-tile-title>
              <v-list-tile-sub-title>{{ $t('profile.ResidencyStart') }}</v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>

          <v-divider inset />
          <v-list-tile>
            <v-list-tile-action>
              <v-icon color="indigo">mail</v-icon>
            </v-list-tile-action>

            <v-list-tile-content>
              <v-list-tile-title>{{ contact.email }}</v-list-tile-title>
              <v-list-tile-sub-title>Personal</v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>

          <v-divider inset />

          <v-list-tile>
            <v-list-tile-action>
              <v-icon color="indigo">location_on</v-icon>
            </v-list-tile-action>

            <v-list-tile-content>
              <v-list-tile-title>{{ hospital }}</v-list-tile-title>
              <v-list-tile-sub-title>Lisbon, Portugal</v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapActions } from 'vuex'
import cms from '@/content'
export default {
  props: {
    contactId: String
  },
  data() {
    return {
      contact: null
    }
  },
  computed: {
    hospital() {
      const hospitalId = this.contact ? this.contact.hospital : undefined
      return cms.getHospitalName(hospitalId)
    },
    residencyStart(){
      return this.$store.getters.residencyStart
    },
    residencyYear(){
      return this.residencyStart ? this.$store.getters.residencyYear : ''
    }
  },
  created() {
    this.getContact(this.contactId).then(contact => (this.contact = contact))
    // TODO: handle error
  },
  methods: {
    ...mapActions(['getContact'])
  }
}
</script>
